export default function setLocaleForCurrentUser({ state }) {
  let {
    currentUser,
    locales,
    registrating: { current: { common } }
  } = state.get('client')
  let locale = locales[0]
  if (currentUser) {
    locale = currentUser.currentClient.locale
    if (locales.indexOf(currentUser.currentClient.locale) === -1) {
      locale = locales[0]
    }
  }

  let options = []
  let selectedOption = common.locale.options.reduce((acc, option) => {
    let { key, i18nKey, value, index } = option
    let newOption = {
      key,
      i18nKey,
      value,
      index,
      selected: false
    }
    if (key === locale) {
      newOption.selected = true
      acc.push(newOption)
    }
    options.push(newOption)
    return acc
  }, [])
  state.merge('client.registrating.current.common.locale', {
    value: selectedOption,
    options
  })
}



// WEBPACK FOOTER //
// ./src/modules/user/actions/setLocaleForCurrentUser.js